import { useGetRoot } from '@/common-queries/use-get-root';
import { TranslationComponentProps } from '@/types/translation';

import { ShopItemView } from './shop-item-view';

type ShopItemDataProps = {} & TranslationComponentProps;

export function ShopItemData({ t }: ShopItemDataProps) {
  const { data } = useGetRoot();

  const available = data?.data?.available;

  if (!available) {
    return false;
  }

  return <ShopItemView t={t} />;
}
